import './LayoutChat.css';
import Header from '../Component/Header/Header';
import Copyright from '../Component/Copyright/Copyright';

export default function ChatLayout(props) {
  return (
    <div className="chatlayout-layout-container">
      <div className="chatlayout-header-container">
        <Header />
      </div>
      <div className="chatlayout-content-container">
        {props.children}
      </div>

    </div>
  )
}